import { Line } from './line.model';
import { ProcessType } from './process-type.model';

export class Equipment {

    public id: number;
    public name: string;
    public displayName: string;
    public description: string;
    public MESId: string;
    public inUse: boolean;
    public line: Line;
    public lineId: number;
    public processTypes: ProcessType[];

    static mapLine(line = {}) {
        return new Line(line || {});
    }

    static get type() {
        return 'equipment';
    }

    constructor(equipment: any = {}) {
        this.id = equipment.id || 0;
        this.name = equipment.name || '';
        this.description = equipment.description || '';
        this.MESId = equipment.MESId || '';
        this.inUse = equipment.inUse;
        this.displayName = equipment.displayName || this.name + ' ' + this.MESId;
        this.processTypes = this.mapProcessTypes(equipment.processTypes);
        this.line = Equipment.mapLine(equipment.line);
        this.lineId = equipment.lineId || 0;
    }

    mapProcessTypes(processTypes = []) {
        return processTypes.map(prc => new ProcessType(prc));
    }

    get nameWithLine() {
        return `${this.displayName}_${this.line.name}`;
    }
}
